module.exports = __webpack_public_path__ + "static/img/6.f4e243d9.png";